// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"NBpUA","hidden":"_2Hm-S","container":"_31s8_","fillAllSpace":"_2r6y1","fullScreen":"_2xwks"};